export default __webpack_public_path__ + "static/media/icon_benefits_zoom.f77392aa.svg";